export default __webpack_public_path__ + "static/john-10d3b827ae3e4e14cb236efc8ede7f39.png";